import { CheckoutState } from '../../state';
import { getNamespaceValue } from '../utils/selector';

export const getHasBogoTickets = (state: CheckoutState): boolean => {
    return getNamespaceValue(state.event, 'hasBogoTickets');
};
